import { isValidPhoneNumber } from "libphonenumber-js/max";
import { type IssueData, z } from "zod";

const PhoneNumberInvalidError: IssueData = {
  code: z.ZodIssueCode.custom,
  params: { i18n: "custom.phone_number_invalid" },
};

/**
 * 電話番号のschema定義
 *
 * Optional/Requiredは設定しないので、利用側で設定してください
 */
export const phoneNumberSchema = (dialCode?: string) =>
  z.string().superRefine((val, ctx) => {
    // 任意入力のケースもあるので、undefined, null, "" はチェックしない
    // 必須の場合はここではなく別でチェックすること
    if (val === undefined || val === null || val === "") return;
    if (!isValidPhoneNumber(val, { defaultCallingCode: dialCode })) {
      ctx.addIssue(PhoneNumberInvalidError);
    }
  });
